export const ScheduleFrequencies = {
	Daily: "Daily",
	Weekly: "Weekly",
};

export const ScheduleFrequencyOptions = [
	{ value: ScheduleFrequencies.Daily, label: "Daily" },
	{ value: ScheduleFrequencies.Weekly, label: "Weekly" },
];
